export default "__VITE_ASSET__DXzCE3kV__"